import { resolveRoute } from "@analytics-setup/routeTracking";
// Which What's New placement a Discover page is. Marketing picks placements in plain terms in the
// admin form; this is where they meet the routes, and the one place to update when pages change.
const PLACEMENT_BY_ROUTE = {
    home: "home",
    community: "community",
    overview: "report",
    results: "report",
    "report-settings": "report",
    "report-settings-topics": "report",
    "report-settings-competitors": "report",
};
/** The placement for a pathname, or `null` for pages that never pop anything up. */
export const getWhatsNewPlacement = (pathname) => { var _a; return (_a = PLACEMENT_BY_ROUTE[resolveRoute(pathname).routeName]) !== null && _a !== void 0 ? _a : null; };
